module.exports = __webpack_public_path__ + "static/media/sn.4cf72c7b.webp";